export default __webpack_public_path__ + "static/media/no-bot.d80d2537.png";